<template>
  <div class="sticky top-8">
    <UCard :ui="{ rounded: 'rounded-none md:rounded-lg' }">
      <div class="space-y-6">
        <!-- Özet Başlığı -->
        <USkeleton class="h-6 w-32" />

        <!-- Fiyat Detayları -->
        <div class="space-y-4">
          <div class="flex justify-between">
            <USkeleton class="h-4 w-24" />
            <USkeleton class="h-4 w-20" />
          </div>
          <div class="flex justify-between">
            <USkeleton class="h-4 w-16" />
            <USkeleton class="h-4 w-20" />
          </div>
        </div>

        <!-- Toplam -->
        <div class="pt-6 border-t">
          <div class="flex justify-between items-center">
            <USkeleton class="h-5 w-16" />
            <USkeleton class="h-6 w-24" />
          </div>
        </div>

        <!-- Butonlar -->
        <USkeleton class="h-10 w-full" />
        <USkeleton class="h-10 w-full" />
      </div>
    </UCard>
  </div>
</template>
